<template>
  <Card>
    <HeadingMedium
      :class="$style.headerBorder"
      hasMargin
    >
      {{ adminConfig.title }}
      <Icon
        icon="info"
      />
    </HeadingMedium>
    <ParagraphBody>
      <MarkdownInline :mdTemplate="adminConfig.configBodyText" />
    </ParagraphBody>
    <template v-slot:footer>
      <ParagraphBody>
        <QrCodeEnrollmentModal
          v-if="buttonClick"
          :enterpriseObjectId="googleEmmEnterpriseObj.enterpriseObjectId"
          :headerText="headerText"
          :organizationObjectId="googleEmmEnterpriseObj.organizationObjectId"
          @close-enrollment-instructions="handlecloseenrollment"
        />
        <ButtonSecondary
          :text="adminConfig.buttonText"
          @click="handleButtonClick"
        />
      </ParagraphBody>
    </template>
  </Card>
</template>

<script>
import { AndroidEmmConsts, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import {
  ButtonSecondary,
  Card,
  HeadingMedium,
  Icon,
  MarkdownInline,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import QrCodeEnrollmentModal from 'client/MDM/components/QrCodeEnrollmentModal.vue';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];

export default {
  name: 'GoogleEmmAdminConfig',

  components: {
    ButtonSecondary,
    Card,
    HeadingMedium,
    Icon,
    MarkdownInline,
    ParagraphBody,
    QrCodeEnrollmentModal,
  },

  data: () => ({
    adminConfig: AndroidEmmConsts.androidEmmAdminConfigText,
    headerText: AndroidEmmConsts.androidEmmQrEnrollmentText.title,
    buttonClick: false,
  }),

  computed: {
    ...mapState(googleModule, [
      'googleEmmEnterpriseObj',
    ]),
  },

  methods: {
    handleButtonClick() {
      this.buttonClick = true;
    },

    handlecloseenrollment() {
      this.buttonClick = false;
    },
  },
};
</script>

<style module>
.headerBorder {
  border-bottom: var(--jc-border);
  padding-bottom: var(--jc-spacer);
}

.headerBorder span svg {
  margin-left: 0.75rem;
  margin-top: var(--jc-spacer-x-small);
  position: absolute;
}
</style>
